module.exports = __webpack_public_path__ + "assets/img/fb2d5025096833a6c0a7155526bbfbd7.svg";